import {useScrollToComments} from '../../../../comments/use-scroll-to-comments'
import {useAllThreads} from '../../../../../stores/layout-selectors'
import {MiniMergeStatusItem} from './MiniMergeStatusItem'
import {MiniMergeStatusBoundary} from './MiniMergeStatusBoundary'

export function CommentsMiniStatus() {
  const scrollToComments = useScrollToComments()
  const threads = useAllThreads()
  const totalThreads = threads.length
  const resolvedThreads = threads.filter(thread => thread.isResolved).length
  const iconType = totalThreads === 0 ? 'neutral' : resolvedThreads === totalThreads ? 'success' : 'warning'

  return (
    <MiniMergeStatusItem aria-label="Resolved comments">
      <MiniMergeStatusItem.LabelRow>
        <MiniMergeStatusItem.Label icon={iconType} successful={resolvedThreads} total={totalThreads}>
          Resolved comments
        </MiniMergeStatusItem.Label>
        <MiniMergeStatusItem.Action aria-label="View comments" onClick={scrollToComments} />
      </MiniMergeStatusItem.LabelRow>
      <MiniMergeStatusItem.Progress
        aria-label={`${resolvedThreads} of ${totalThreads} resolved comments`}
        successful={resolvedThreads}
        total={totalThreads}
      />
    </MiniMergeStatusItem>
  )
}

export function CommentsMiniStatusBoundary({children}: {children: React.ReactNode}) {
  const scrollToComments = useScrollToComments()

  return (
    <MiniMergeStatusBoundary
      action={scrollToComments}
      actionLabel="View comments"
      boundaryName="CommentsMiniStatusBoundary"
      text="Resolved comments"
    >
      {children}
    </MiniMergeStatusBoundary>
  )
}
